/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Rapat_S3Inputs */

const en_tut_rapat_s3 = /** @type {(inputs: Tut_Rapat_S3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The host presses **Mulai meeting**. Participants press **Siapkan kamera & mikrofon**, choose devices, then **Gabung meeting** — microphone and camera start off.`)
};

const id_tut_rapat_s3 = /** @type {(inputs: Tut_Rapat_S3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Host menekan **Mulai meeting**. Peserta menekan **Siapkan kamera & mikrofon**, memilih perangkat, lalu **Gabung meeting** — mikrofon dan kamera mulai dalam keadaan mati.`)
};

/**
* | output |
* | --- |
* | "The host presses **Mulai meeting**. Participants press **Siapkan kamera & mikrofon**, choose devices, then **Gabung meeting** — microphone and camera start off." |
*
* @param {Tut_Rapat_S3Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_rapat_s3 = /** @type {((inputs?: Tut_Rapat_S3Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Rapat_S3Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_rapat_s3(inputs)
	return en_tut_rapat_s3(inputs)
});